export function meterToPx(meter) {
	if (meter === null || meter === undefined) return 0;
	// m -> m factor (based on m12 size)
	const factor = 90 / 0.785;
	const px = Math.round(parseFloat(meter.replace(',', '.')) * factor);
	return isNaN(px)?0:px;
}

export function mmToPx(mm) {
	if (mm === null || mm === undefined) return 0;
	const factor = 90 / 785;
	const px = Math.round(parseFloat(mm.replace(',', '.')) * factor);
	return isNaN(px)?0:px;
}

